$(function() {
  $('.js-to-top').on('click', function() {
    $('html, body').scrollTop(0)
  })

  $('.js-to-el').on('click', function() {
    $('.js-to-target').scrollTop(0)
  })
})
